import { Dispatch } from 'redux';
import { History } from 'history';
import { logger } from 'shared/logging';
import {
  getConfigFlags,
  getOneTapData,
  getRequestId,
  getTrueCallerStatus,
  getGeoSubdivision,
} from './service';
import actions from './actionTypes';
import { setCookie } from '@nykaa/nes-utils/cookies';
import {
  ADDRESS_COUNTRY_CODE_FOR_DELIVERY,
  RUN_MAX_AGE,
} from 'constants/cookies';
import { ADDRESS_COUNTRY_DATA_FOR_DELIVERY } from '@nykaa/nes-delivery-shared/constants';

export const fetchConfigFlags = () => (dispatch: Dispatch) =>
  getConfigFlags().then((configFlags) => {
    dispatch({
      type: actions.CONFIG_FLAGS,
      payload: configFlags,
    });
  });

export const fetchGeoSubdivision = () => (dispatch: Dispatch) =>
  getGeoSubdivision().then((geoSubdivision) => {
    setCookie(
      ADDRESS_COUNTRY_CODE_FOR_DELIVERY,
      geoSubdivision[0].country,
      RUN_MAX_AGE
    );
    setCookie(
      ADDRESS_COUNTRY_DATA_FOR_DELIVERY,
      JSON.stringify(geoSubdivision[0]),
      RUN_MAX_AGE
    );
    dispatch({
      type: actions.GEO_SUBDIVISION,
      payload: geoSubdivision,
    });
  });

export const setRUN = (run: number) => (dispatch: Dispatch) => {
  dispatch({
    type: actions.SET_RUN,
    payload: run,
  });
};

export const showSignUp = () => (dispatch: Dispatch) => {
  dispatch({
    type: actions.SET_SIGNUP,
    payload: true,
  });
};
export const setLoginAutoTriggered = () => (dispatch: Dispatch) => {
  dispatch({
    type: actions.SET_LOGIN_AUTO_TRIGGERED,
    payload: true,
  });
};
export const hideSignUp = (history: History) => (dispatch: Dispatch) => {
  const { authStep = 0 } = history.location?.state || {};

  if (authStep) {
    history.go(-authStep);
  }
  dispatch({
    type: actions.SET_SIGNUP,
    payload: false,
  });
  dispatch({
    type: actions.SET_LOGIN_AUTO_TRIGGERED,
    payload: false,
  });
};

export const showProfile = () => (dispatch: Dispatch) => {
  dispatch({
    type: actions.SET_PROFILE,
    payload: true,
  });
};

export const hideProfile = () => (dispatch: Dispatch) => {
  dispatch({
    type: actions.SET_PROFILE,
    payload: false,
  });
};

export const fetchOneTapData = (params: any) => () =>
  getOneTapData(params).then((data) => data);

export const fetchRequestId = () => () =>
  getRequestId()
    .then((requestId: string) => requestId)
    .catch((err: Error) => {
      logger.error(err, 'Error in Fetch Truecaller requestId');
      return '';
    });

interface TruecallerProps {
  requestId: string;
}
export const fetchTrueCallerStatus =
  (requestParams: TruecallerProps) => (dispatch: Dispatch) => {
    dispatch({
      type: actions.TRUECALLER_STATUS_FETCHING,
    });
    return getTrueCallerStatus(requestParams)
      .then((response: any) => {
        dispatch({
          type: actions.TRUECALLER_STATUS_SUCCESS,
        });
        if (response) {
          return response;
        }
      })
      .catch((err: Error) => {
        dispatch({
          type: actions.TRUECALLER_STATUS_FAILURE,
        });
        logger.error(err, 'Error in Fetch Truecaller requestId');
      });
  };

export const updatePageStatusCode =
  (status: number) => (dispatch: Dispatch) => {
    dispatch({
      type: actions.APP_REDUCER_STATUS_CODE,
      payload: status,
    });
  };

export const setBackToTop = (position: number) => (dispatch: Dispatch) => {
  dispatch({
    type: actions.SET_BACK_TO_TOP_POSITION,
    payload: position,
  });
};

export const setCartNudgeStatus =
  (isVisible: boolean, position: number) => (dispatch: Dispatch) => {
    dispatch({
      type: actions.UPDATE_CART_NUDGE_STATUS,
      payload: {
        isVisible,
        position,
      },
    });
  };

export const setAppInstallNudgeStatus =
  (isVisible: boolean, position: number) => (dispatch: Dispatch) => {
    dispatch({
      type: actions.UPDATE_APP_INSTALL_NUDGE_STATUS,
      payload: {
        isVisible,
        position,
      },
    });
  };
